import React, { Component } from 'react';
import { Group } from '@vx/group';
import { GlyphDot } from '@vx/glyph';
import { LinePath } from '@vx/shape';
import { scaleLinear, scaleTime } from '@vx/scale';
import { extent, max, min } from 'd3-array';

class LineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    const data = this.props.data;

    // accessors
    const x = d => d.x;
    const y = d => d.y;

    const width = 100;
    const height = 80;

    const margin = {
      top: 5,
      bottom: 30,
      left: 10,
      right: 10
    }

    const xMax = width - margin.left - margin.right;
    const yMax = height - margin.top - margin.bottom;

    // scales
    const xScale = scaleLinear({
      range: [margin.left, xMax],
      domain: extent(data, x),
      nice: true
    });
    const yScale = scaleLinear({
      range: [yMax, margin.top],
      domain: extent(data, y),
      nice: true
    });

    let hasIncreased = null;
    let percDiff = null;
    const currentPrice = data[data.length - 1].y;
    let color = '#ddd';

    if (data.length > 2) {
      const prevPrice = data[data.length - 2].y;
      const priceDiff = currentPrice - prevPrice;
      percDiff = ((priceDiff / prevPrice) * 100).toFixed(2);
      hasIncreased = percDiff > 0;
      color = hasIncreased ? "red" : "#73E8B0";
    }
    
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column"
        }}
      >
      { percDiff && 
        <span
          style={{
            color: color,
            textAlign: "right",
            paddingRight: "2px",
            fontSize: "14px",
            fontWeight: 500
          }}
        >
          { `${hasIncreased ? "+": ""}${percDiff}%` }
        </span>}
        <svg width={width} height={height}>
        <Group top={margin.top}>
          <LinePath
            data={data}
            xScale={xScale}
            yScale={yScale}
            x={x}
            y={y}
            stroke={color}
            strokeWidth={3}
            glyph={(d,i) => {
              return (
                <g key={`line-point-${i}`}>
                  <GlyphDot
                    cx={xScale(x(d))}
                    cy={yScale(y(d))}
                    r={6}
                    fill='#fcfeff'
                    stroke={color}
                    strokeWidth={3}
                  />
                </g>
              );
            }}
            
          />
        </Group>
      </svg>
    </div>
    );
  }
}

export default LineChart;



// WEBPACK FOOTER //
// ./src/components/linechart/index.js